<template>
  <section id="card-text-alignment">
    <h3 class="mt-3 mb-2">
      Método de Pagamento
    </h3>
    <b-row>
      <!-- center align -->
      <b-col
        v-for="(item, index) in payments"
        md="6"
        lg="4"
      >
        <b-card
          :title="item.name"
          class="text-center"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            v-b-modal.modal-select2
            variant="outline-primary"
            :to="{ name: 'notifications-status-edit', params: { status: 2, paymentId: item.paymentId, uuid: uuid } }"
          >
            Editar
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow, BCol, BCard, BCardText, BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      value: '',
      payments: [
        {
          paymentId: 2,
          name: 'Boleto',
        },
        {
          paymentId: 6,
          name: 'Pix',
        }],
      statusName: null,
      statusId: null,
      uuid: this.$route.params.uuid,
    }
  },
  methods: {
    teste(id, name) {
      this.statusId = id
      this.statusName = name
    },
  },
}
</script>
